export enum RoutePaths {
  Login = "/innlogging",
  NoAccess = "/ingen-tilgang",
  MosqueRequestForm = "/ny-moske",
  DonationThanks = "/donasjon/takk",
  DonationCancelled = "/donasjon/avbrutt",
  SuperAdminMosqueSelection = "/velg-moske",
  Root = "/",
  Jamat = "/jamat",
  PrayerTimes = "/bonnetider",
  SpecialPrayerSettings = "/spesielle-bonnetider",
  Notification = "/push-meldinger",
  Event = "/aktiviteter",
  Blog = "/blogg",
  Posters = "/tv-admin",
  PostersAll = "/plakater",
  Information = "/informasjon",
  Campaign = "/kampanje",
  MyMosqueLayout = "/min-moske-oppsett",
  PaymentSettings = "/betaling",
  /** Moské-admin: gaver gitt i appen. */
  Donations = "/innsamlet",
  MosqueAdmin = "/moske-admin",
  Dua = "/dua",
  HijriDates = "/hijri-datoer",
  Users = "/brukere",
  Locations = "/lokasjoner",
  SuperAdminPrayerTimes = "/bonne-tider-admin",
  /** Superadmin: generer IRN- eller Mawaqeet-tider og lagre dem (fane under Bønnetider). */
  SuperAdminGenerateTimes = "/bonne-tider-admin/generer",
  NamesOfAllah = "/allahs-navn",
  Expressions = "/vanlige-uttrykk",
  GlobalPush = "/global-push-melding",
  AdminPush = "/admin-push-melding",
  PushLog = "/push-logg",
  DirectPush = "/push-til-bruker",
  Hadith = "/hadith",
  AiImam = "/ai-imam",
  AiBonnPrompter = "/aibonn-prompter",
  Quran = "/quran",
  Cache = "/cache",
  External = "/external",
  Janazah = "/janazah",
  JanazahAiLog = "/janazah/ai-logg",
  FuneralAgencies = "/janazah/byraer",
  Registreringer = "/registreringer",
  AiBonFeedback = "/aibonn-tilbakemeldinger",
  MosqueStats = "/moske-statistikk",
  Overview = "/oversikt",
  /** Superadmin: hva som brukes i appen (Firebase Analytics + egne tabeller). */
  AppUsage = "/bruk-av-appen",
  /** Superadmin: gaver gitt i appen, alle moskeer. */
  AdminDonations = "/innsamlet-alle",
  Inquiries = "/henvendelser",
  ContactInbox = "/henvendelser/innboks",
  AdminRequests = "/henvendelser/admin-soknader",
  MosqueSuggestions = "/henvendelser/nye-moskeer",
  ApiKeys = "/api-nokler",
  /** Superadmin: partnere som viser iBønn-widgeten på egen nettside. */
  Partners = "/partnere",
  Kids = "/barn",
  /** Partnerens admins: widget-nøkler og bruk (egen side utenfor admin-menyen). */
  Partner = "/partner",
  Api = "/api",
  Admins = "/administratorer",
  Tv = "/tv",
  TvStudio = "/tv-studio",
  TvSchedule = "/tv-visningsplan",
  TvDevices = "/tv-skjermer",
  TvAiLog = "/tv-skjermer/ai-logg",
  PdfGenerator = "/pdf-generator",
  /** Gamle adresser (før PDF-generatoren): sendes videre dit. */
  PrayerCalendar = "/bonnetider-pdf",
  RamadanCalendar = "/ramadan-kalender",
  PrayerCalendarLog = "/kalender-logg",
  MawaqeetPush = "/mawaqeet-push-meldinger",
  MawaqeetPrayerTimes = "/mawaqeet-bonnetider",
  MawaqeetLocations = "/mawaqeet-lokasjoner",
  MawaqeetGenerateTimes = "/mawaqeet-generer-tider",
  MawaqeetRamadan = "/mawaqeet-ramadan",
  NotFound = "*",
}
